import { Button, Popconfirm } from 'antd';

interface TwoFactorSwitchProps {
  method: string;
  isOn: boolean;
  /** False without a password: two-factor guards password sign-in, so there is nothing to turn on. */
  canTurnOn: boolean;
  submitting: boolean;
  onTurnOn: () => void;
  onTurnOff: () => void;
}

/** "Turn on", or "Turn off" after a question: turning a second factor off weakens password sign-in. */
export function TwoFactorSwitch({ method, isOn, canTurnOn, submitting, onTurnOn, onTurnOff }: TwoFactorSwitchProps) {
  if (!isOn) {
    return (
      <Button type="primary" disabled={!canTurnOn} loading={submitting} onClick={onTurnOn}>
        Turn on
      </Button>
    );
  }
  return (
    <Popconfirm title={`Turn off ${method}?`} okText="Turn off" okButtonProps={{ danger: true }} onConfirm={onTurnOff}>
      <Button danger loading={submitting}>
        Turn off
      </Button>
    </Popconfirm>
  );
}
